import { api } from '@/utils/api';

export const useOrgUpdateMutation = () => {
  const utils = api.useUtils();

  return api.org.update.useMutation({
    onSuccess: async (_ret, { orgId }) => {
      await utils.sharing.paginated.invalidate();
      await utils.org.id.invalidate();
      await utils.org.byId.invalidate();
      await utils.org.detailPage.invalidate({ orgId });
    },
  });
};

export const useMakeOrgFieldPrimaryMutation = () => {
  const utils = api.useUtils();
  return api.org.setPrimaryField.useMutation({
    onSuccess: async (_ret, { orgId }) => {
      await Promise.all([utils.org.id.invalidate(), utils.org.detailPage.invalidate({ orgId })]);
    },
  });
};

export const useRemoveOrgFieldValueMutation = () => {
  const utils = api.useUtils();
  return api.org.deleteValue.useMutation({
    onSuccess: async (_ret, { orgId }) => {
      await Promise.all([utils.org.id.invalidate(), utils.org.detailPage.invalidate({ orgId })]);
    },
  });
};

export const useRemoveOrgFieldPrimaryMutation = () => {
  const utils = api.useUtils();
  return api.org.unsetPrimaryField.useMutation({
    onSuccess: async (_ret, { orgId }) => {
      await Promise.all([utils.org.id.invalidate(), utils.org.detailPage.invalidate({ orgId })]);
    },
  });
};

export const useOrgSetFlagsMutation = () => {
  const utils = api.useUtils();
  return api.org.setFlags.useMutation({
    onSuccess: async (_ret, { orgId }) => {
      await utils.org.detailPage.invalidate({ orgId });
      // Signals depend on these flags; nudge contact queries that surface signals.
      // contactSignalTemplate.forContact still backs other surfaces; the contact
      // detail page now reads signals via contactDetailBootstrap.secondaryForContact.
      await Promise.all([
        utils.contactSignalTemplate.forContact.invalidate(),
        utils.contactDetailBootstrap.secondaryForContact.invalidate(),
      ]);
    },
  });
};

export const useOrgSetStageMutation = () => {
  const utils = api.useUtils();

  return api.org.setStage.useMutation({
    onSuccess: async (ret, { orgId }) => {
      await utils.sharing.paginated.invalidate();
      await utils.org.id.invalidate({ orgId });
      await utils.stage.withOrgs.invalidate();
      //contact.byId returns org, so need to clear it out
      await utils.contact.byId.invalidate();
    },
  });
};

export const useOrgBulkSetStageMutation = () => {
  const utils = api.useUtils();

  return api.org.bulkSetStage.useMutation({
    // onMutate: ({ teamId, stageId, orgId }) => {
    //   utils.org.id.setData({ orgId }, (data) => Object.assign({}, data, { stageId }));
    //   utils.org.byStage.setData({ teamId }, (data) => {
    //     const orgsByStageId = data?.orgsByStageId;
    //     if (orgsByStageId == null) return data;
    //     else {
    //       const org = Object.values(orgsByStageId)
    //         .flat()
    //         .find((o) => o.id === orgId);
    //       const oldStageId = org?.stageId;
    //       if (org && oldStageId && stageId && oldStageId != stageId) {
    //         const orgsAtNewStage = [
    //           ...((stageId ? orgsByStageId[stageId] : undefined) || []),
    //           Object.assign({}, org, { stageId }),
    //         ];
    //         const orgsAtOldStage = orgsByStageId[oldStageId]?.filter((o) => o.id !== orgId);
    //         return Object.assign({}, data, {
    //           orgsByStageId: Object.assign({}, orgsByStageId, {
    //             [oldStageId]: orgsAtOldStage,
    //             [stageId]: orgsAtNewStage,
    //           }),
    //         });
    //       } else {
    //         return data;
    //       }
    //     }
    //   });
    // },
    onSuccess: () => {
      void utils.sharing.paginated.invalidate();
      void utils.org.id.invalidate();

      //contact.id returns org, so need to clear it out
      void utils.contact.byId.invalidate();
      void utils.org.forStage.invalidate();

      // void utils.stage.allV2.invalidate();
      void utils.stage.withContacts.invalidate();
      void utils.stage.withOrgs.invalidate();
    },
  });
};
